import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "antd";
import { SubmitHandler, useForm } from "react-hook-form";
import * as z from "zod";
import FieldInput from "./fields/FieldInput";
import { Theme } from "../../types/thematiques";

const schema = z.object({
  code: z.string().min(1, "Requis").max(20, "20 caractÃ¨res max"),
  description: z.string().max(150, "150 caractÃ¨res max").optional(),
});

export type SchemaFormTheme = z.infer<typeof schema>;

export const transformThemeToFormValues = (theme?: Theme): SchemaFormTheme => {
  if (!theme) return { code: "", description: "" };
  return { code: theme.code, description: theme.description ?? "" };
};

type Props = {
  onSubmit: SubmitHandler<SchemaFormTheme>;
  defaultValues?: SchemaFormTheme;
};

const FormTheme: React.FC<Props> = ({ onSubmit, defaultValues }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<SchemaFormTheme>({
    defaultValues,
    resolver: zodResolver(schema),
  });

  return (
    <Form onFinish={handleSubmit(onSubmit)} id="form-theme">
      <FieldInput<SchemaFormTheme>
        control={control}
        name="code"
        label="Code"
        placeholder="Code..."
        errorMessage={errors?.code?.message}
        isVertical
      />
      <FieldInput<SchemaFormTheme>
        control={control}
        name="description"
        label="Description"
        placeholder="Description..."
        errorMessage={errors?.description?.message}
        isVertical
      />
    </Form>
  );
};

export default FormTheme;
